import { render, staticRenderFns } from "./PriorityText.vue?vue&type=template&id=eabd70be"
import script from "./PriorityText.vue?vue&type=script&lang=js"
export * from "./PriorityText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports